import styled, { css } from 'styled-components';

import type { ICartTheme } from '@/shared/themes/types';

export const YouOrder = styled.h2`
  ${({ theme }) => css`
    height: 33px;
    margin: 32px 0 8px 0;
    font-size: ${theme.fontSizes.extraLarge};
    font-weight: ${theme.fontWeight.medium};
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${theme.defaultDarkColor};
  `}
`;

export const TitleCartSplit = styled.div`
  ${({ theme }: { theme: ICartTheme }) => css`
    font-size: ${theme.fontSizes.medium};
    color: ${theme.defaultDarkColor};
    margin-bottom: 16px;
  `}
`;
